import { platform, tmpdir } from 'os';
import { join } from 'path';
import { exists as _exists, mkdir as _mkdir, readFileSync, statSync } from 'fs';
import { promisify } from 'util';
import { spawnSync } from 'child_process';
import * as path from 'path';

export function fileExists(filePath: string): boolean {
  try {
    return statSync(filePath).isFile();
  } catch (err) {
    return false;
  }
}

const exists = promisify(_exists);
const mkdir = promisify(_mkdir);

// noinspection TsLint
// tslint:disable-next-line:no-var-requires

export async function readAffectedDepGraph(
  cwd: string,
  base: string,
  head: string
) {
  const tmp = await getTmpDir();
  const tmpFilePath = join(tmp, 'affected-graph.json');
  const angularJSON = JSON.parse(
    readFileSync(join(cwd, 'angular.json')).toString()
  );
  const args = [
    'affected:dep-graph',
    `--file=${tmpFilePath}`,
    `--base=${base}`
  ];
  if (head) {
    args.push(`--head=${head}`);
  }

  try {
    const nx = findNx(cwd);
    if (!fileExists(nx)) {
      return {};
    }
    const r = spawnSync(nx, args, { cwd });
    if (r.error) {
      throw new Error(r.error.toString());
    }
    const fileContent = JSON.parse(readFileSync(tmpFilePath).toString());
    const result = {
      ...fileContent,
      projectTypes: Object.keys(angularJSON.projects).reduce(
        (acc, k) => {
          acc[k] = angularJSON.projects[k].projectType;
          return acc;
        },
        {} as any
      )
    };
    transformIntoDag(result);
    return result;
  } catch (e) {
    console.error(e);
    throw new Error(`Cannot get the graph information. ${e.message}`);
  }
}

export function transformIntoDag(graph: any): any {
  Object.keys(graph.deps).forEach(sourceProjectName => {
    graph.deps[sourceProjectName] = graph.deps[sourceProjectName].reduce(
      (m: string[], targetProject: { projectName: string }) => {
        const targetProjectName = targetProject.projectName;
        const sourceProjectType = graph.projectTypes[sourceProjectName];
        const targetProjectType = graph.projectTypes[targetProjectName];
        if (depends(targetProjectName, sourceProjectName, graph)) {
          if (
            (sourceProjectType === 'application' &&
              targetProjectType !== 'application') ||
            sourceProjectName.localeCompare(targetProjectName) === 1
          ) {
            return m;
          } else {
            return [...m, targetProject];
          }
        } else {
          return [...m, targetProject];
        }
      },
      []
    );
  });
}

function depends(source: string, target: string, graph: any): boolean {
  function traverse(
    traversalPath: string[],
    deps: { projectName: string }[]
  ): boolean {
    if (!deps) return false;
    return !!deps.find(d => {
      if (d.projectName === target) return true;
      if (traversalPath.indexOf(d.projectName) > -1) return false;
      return traverse(
        [...traversalPath, d.projectName],
        graph.deps[d.projectName]
      );
    });
  }

  return traverse([source], graph.deps[source]);
}

async function getTmpDir() {
  const p = join(tmpdir(), 'angular-console');
  if (!(await exists(p))) {
    await mkdir(p);
  }

  return p;
}

export function findNx(dir: string): string {
  if (directoryExists(path.join(dir, 'node_modules'))) {
    if (platform() === 'win32') {
      return path.join(dir, 'node_modules', '.bin', 'nx.cmd');
    } else {
      return path.join(dir, 'node_modules', '.bin', 'nx');
    }
  } else {
    throw new Error(`Cannot find node_modules`);
  }
}

export function directoryExists(filePath: string): boolean {
  try {
    return statSync(filePath).isDirectory();
  } catch (err) {
    return false;
  }
}
